import cn from 'classnames';
import { useEffect, useState } from 'react';

import type { Link } from './data';
import { checkIsActive, getPathname } from './lib';

import css from './menu.css';

export const MenuItem: FC<Link & { nextRouter?: { asPath: string } }> = ({ links, name, path, nextRouter }) => {
    const location = typeof window !== 'undefined' && window.location;
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const pathname = nextRouter ? nextRouter.asPath : location.pathname ?? '';
        let slug = pathname.split('?')[0];
        slug = slug.split('/').pop();
        setIsActive(checkIsActive({ name, path, links }, slug));
    }, [nextRouter, path, links, location.pathname, name]);

    if (!isActive || !links) {
        const href = `/ru/${getPathname({ path, links, name })}`;

        return (
            <li className={cn(css.item, { [css.active]: isActive })}>
                <a className={cn(css.link, name === 'Конфиденциальность' && css.confidential)} href={href}>
                    {name}
                </a>
            </li>
        );
    }
    const link = links[0].path || links[0].links[0].path;
    return (
        <div className={cn(css.item, { [css.active]: isActive })}>
            <a className={css.action} href={link}>
                {name}
            </a>
            <div className={cn(css.sub, { [css.visible]: isActive })}>
                <MenuItems links={links} />
            </div>
        </div>
    );
};

export const MenuItems: FC<{
    links: Array<Link>;
    nextRouter?: { asPath: string };
}> = ({ links, nextRouter }) => (
    <ul className={css.links}>
        {links.map((link) => (
            <MenuItem key={link.name} {...link} nextRouter={nextRouter} />
        ))}
    </ul>
);
